<form
  (ngSubmit)="emitLastSelectedStreet()"
  [formGroup]="form"
  autocomplete="off"
  class="container"
  novalidate>
  <app-menu
    (closed)="showEmptyResults = false"
    [enabled]="suggestions.length > 0 || showEmptyResults === true"
    appearance="full-screen"
    class="autocomplete search-mobile">
    <app-input
      [formControl]="form.controls.term"
      [placeholder]="'street.ui.street_search_form.search.placeholder' | translate"
      appAnchor
      autocomplete="off"
      class="solid"
      extras="search"></app-input>
    <ng-template>
      <div *ngIf="showEmptyResults" class="data-empty">
        <p class="weight-semibold color-txt-bold">
          {{ 'street.ui.street_search_form.empty.title' | translate }}
        </p>
        <p class="margin-top">
          {{ 'street.ui.street_search_form.empty.description' | translate }}
        </p>
      </div>
      <app-street-suggestion-item
        (click)="loadPlaceDetails(s)"
        *ngFor="let s of suggestions"
        [value]="s"
        appMenuItem></app-street-suggestion-item>
    </ng-template>
    <ng-container *ngIf="!inputOnly">
      <button
        (click)="showMobileFilters = !showMobileFilters"
        *mediaIf="'small only'"
        [appButton]="slidersIcon"
        [ngClass]="{ primary: showMobileFilters }"
        class="solid square margin-left"></button>
    </ng-container>
  </app-menu>

  <ng-container *ngIf="!inputOnly">
    <ng-container *mediaIf="'medium'; else smallTmpl">
      <app-data-expand class="clear margin-top-lg">
        <span>{{ 'street.ui.street_search_form.asset_type' | translate }}</span>
        <ng-template>
          <ng-container *ngTemplateOutlet="zoneFilterTmpl"></ng-container>
        </ng-template>
      </app-data-expand>

      <app-data-expand class="clear margin-top-md">
        <span>{{ 'street.ui.street_search_form.street_price' | translate }}</span>
        <ng-template>
          <ng-container *ngTemplateOutlet="priceFilterTmpl"></ng-container>
        </ng-template>
      </app-data-expand>

      <div class="clear margin-top-md">
        <button (click)="filterOwn()" [formControl]="onlyOwnControl" appCheckbox>
          {{ 'street.ui.street_search_form.own_streets' | translate }}
        </button>
      </div>
    </ng-container>
  </ng-container>
  <ng-template #smallTmpl>
    <div *ngIf="showMobileFilters" class="mobile-filters">
      <div class="mobile-filter">
        <div class="filter-title">{{ 'street.ui.street_search_form.asset_type' | translate }}</div>
        <ng-container *ngTemplateOutlet="zoneFilterTmpl"></ng-container>
      </div>
      <div class="mobile-filter margin-bottom">
        <div class="filter-title">
          {{ 'street.ui.street_search_form.street_price' | translate }}
        </div>
        <ng-container *ngTemplateOutlet="priceFilterTmpl"></ng-container>
      </div>
      <div class="mobile-filter">
        <button (click)="filterOwn()" [formControl]="onlyOwnControl" appCheckbox>
          {{ 'street.ui.street_search_form.own_streets' | translate }}
        </button>
      </div>
    </div>
  </ng-template>
</form>

<ng-template #zoneFilterTmpl>
  <div *ngFor="let l of form.levels" class="checkbox-wrapper">
    <button (click)="filterTile()" [formControl]="l.control" appCheckbox class="{{ l.icon }}">
      {{ l.title }}
    </button>
  </div>
</ng-template>

<ng-template #priceFilterTmpl>
  <div class="filter-inputs margin-bottom-lg">
    <app-number-input
      [applyChangesOnActive]="true"
      [formControl]="minPriceControl"
      class="price-filter solid"
      title="DWRLD"></app-number-input>
    <div class="display-flex align-center">—</div>
    <app-number-input
      [applyChangesOnActive]="true"
      [formControl]="maxPriceControl"
      class="price-filter solid"
      title="DWRLD"></app-number-input>
  </div>
  <app-twin-range [constraints]="priceRange" [formControl]="rangeControl"></app-twin-range>
</ng-template>
